module.exports = __webpack_public_path__ + "static/media/default_urgent_care_md.2a1f886a.jpeg";